<div
  *ngIf="domOpen"
  #overlayRoot
  class="v2-open-binders"
  [class.v2-open-binders--closing]="isClosing"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'OPEN_BINDERS_HEADER' | translate"
>
  <button
    type="button"
    class="v2-rpc-floating-close"
    (click)="onHeaderBack()"
    [class.v2-rpc-floating-in]="headerReveal"
    [attr.aria-label]="'BUTTON_CLOSE' | translate"
  >
    ×
  </button>

  <!-- Manage-style UI: loading skeleton or 1+ binders to open -->
  <ng-container *ngIf="dataLoading || numBindersToOpen >= 1">
    <div class="manage-header-wrapper">
      <header class="manage-header" [class.opened]="headerReveal" [class.loaded]="headerReveal">
        <span class="manage-header-spacer" aria-hidden="true"></span>
        <div class="manage-header-center">
          <h1 class="manage-header-title">{{ 'OPEN_BINDERS_HEADER' | translate }}</h1>
          <!-- <ion-progress-bar
            *ngIf="operationInProgress"
            type="indeterminate"
            color="primary"
            class="v2-open-binders-progress"
          ></ion-progress-bar> -->
        </div>
        <span class="manage-header-spacer"></span>
      </header>
    </div>

    <div class="manage-content v2-open-binders-scroll">
      <div
        class="manage-wrapper"
        [class.opened]="contentReveal && !dataLoading"
        [class.loaded]="contentReveal && !dataLoading"
      >
        <!-- Skeleton while fetching collection data -->
        <div *ngIf="dataLoading" class="v2-ob-skeleton-panel" aria-busy="true">
          <div class="v2-ob-skeleton-top-row">
            <div class="v2-ob-skeleton-hero"></div>
            <div class="v2-ob-skeleton-stats">
              <div class="v2-ob-skeleton-line"></div>
              <div class="v2-ob-skeleton-line v2-ob-skeleton-line--short"></div>
              <div class="v2-ob-skeleton-line v2-ob-skeleton-line--medium"></div>
            </div>
          </div>
          <div class="v2-ob-skeleton-actions" aria-hidden="true">
            <div class="v2-ob-skeleton-btn-bar"></div>
            <div class="v2-ob-skeleton-btn-bar"></div>
            <div class="v2-ob-skeleton-btn-bar v2-ob-skeleton-btn-bar--short"></div>
          </div>
          <p class="v2-ob-loading-caption">{{ 'LOADING' | translate }}</p>
        </div>

        <ng-container *ngIf="!dataLoading">
          <!-- Hero only: manage-style card panel -->
          <div class="v2-ob-panel v2-ob-panel--top">
            <div class="v2-ob-top-section">
              <div class="v2-ob-collection-image">
                <div class="v2-ob-image-frame" *ngIf="collectionIconPath">
                  <ion-img
                    [ngClass]="{ fade: hasImgLoaded }"
                    class="v2-ob-hero-img"
                    (ionImgDidLoad)="hasLoaded()"
                    [src]="collectionIconPath"
                  ></ion-img>
                  <div
                    class="v2-ob-img-shimmer"
                    *ngIf="!hasImgLoaded"
                    aria-hidden="true"
                  ></div>
                </div>
                <div *ngIf="!collectionIconPath" class="v2-ob-image-placeholder" aria-hidden="true"></div>
              </div>

              <div class="v2-ob-stats-side">
                <h2 class="v2-ob-collection-title">
                  {{ collectionTitle || ('COLLECTION' | translate) }}
                </h2>
                <div class="v2-ob-metric" role="status">
                  <span class="v2-ob-metric-label">{{ 'BINDERS_TO_OPEN' | translate }}</span>
                  <span class="v2-ob-metric-value">{{ numBindersToOpen }}</span>
                </div>
                <p class="v2-ob-meta" *ngIf="pcents > 0 && numBindersToOpen > 0">{{ 'OPEN_BINDERS_TEXT_3' | translate }}</p>
              </div>
            </div>
          </div>

          <p class="v2-ob-section-label ion-text-center">{{ 'OPEN_BINDERS_MULTIPLE_QUESTION' | translate }}</p>
          <div
            class="v2-ob-count-column"
            role="group"
            [attr.aria-label]="'OPEN_BINDERS_MULTIPLE_QUESTION' | translate"
          >
            <app-btn
              *ngFor="let count of getBinderChipValues(); trackBy: trackByChipCount"
              class="v2-ob-count-choice"
              [text]="'OPEN_BINDERS_OPEN_N' | translate: { count: count }"
              [type]="operationInProgress ? 'disabled' : 'neutral'"
              (clicked)="openBinders(count)"
            ></app-btn>
          </div>

          <div
            *ngIf="pcents > 0 || numSpinners >= 1"
            class="v2-ob-secondary-actions"
            role="region"
            aria-labelledby="v2-ob-secondary-heading"
          >
            <h2 class="v2-ob-eyebrow" id="v2-ob-secondary-heading">{{ 'OPEN_BINDERS_MORE_OPTIONS' | translate }}</h2>
            <app-btn
              *ngIf="pcents > 0"
              [text]="'V2_OVERLAY_BUY_MORE' | translate"
              icon="chevron-forward-outline"
              [type]="operationInProgress ? 'disabled' : 'neutral'"
              (clicked)="gotoGet()"
            ></app-btn>

            <app-btn
              *ngIf="numSpinners >= 1"
              [text]="'OPEN_SPINNERS' | translate"
              icon="chevron-forward-outline"
              [type]="operationInProgress ? 'disabled' : 'neutral'"
              (clicked)="gotoOpenSpinners()"
            ></app-btn>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <!-- Same chrome as v2-request-physical-collection when there is nothing to open -->
  <ng-container *ngIf="!dataLoading && numBindersToOpen < 1">
    <div
      class="v2-rpc-title-pill"
      [class.v2-rpc-floating-in]="headerReveal"
      aria-hidden="true"
    >
      {{ 'OPEN_BINDERS_HEADER' | translate }}
    </div>

    <!-- <div class="v2-open-binders-rpc-progress" *ngIf="operationInProgress">
      <ion-progress-bar type="indeterminate" color="primary" class="v2-open-binders-progress"></ion-progress-bar>
    </div> -->

    <div class="v2-rpc-body">
      <div class="v2-rpc-scroll-outer v2-request-phys-col-scroll">
        <div
          class="manage-wrapper v2-req-phys-wrap v2-open-binders-empty-rpc"
          [class.opened]="contentReveal"
          [class.loaded]="contentReveal"
        >
          <main class="v2-rpc-scroll">
            <div class="v2-rpc-item ion-text-wrap ion-text-center" *ngIf="collectionIconPath">
              <div class="v2-ob-empty-rpc-icon">
                <div class="v2-ob-image-frame v2-ob-empty-rpc-icon__frame">
                  <ion-img
                    [ngClass]="{ fade: hasImgLoaded }"
                    class="v2-ob-hero-img"
                    (ionImgDidLoad)="hasLoaded()"
                    [src]="collectionIconPath"
                  ></ion-img>
                  <div
                    class="v2-ob-img-shimmer"
                    *ngIf="!hasImgLoaded"
                    aria-hidden="true"
                  ></div>
                </div>
              </div>
            </div>

            <div class="v2-rpc-item">
              <div class="v2-rpc-lbl">
                <h2 class="ion-text-wrap ion-text-center">{{ 'OPEN_BINDERS_NONE_TO_OPEN' | translate }}</h2>
                <br />
                <p class="ion-text-wrap ion-text-center" *ngIf="pcents <= 0 && numSpinners < 1">
                  {{ 'OPEN_BINDERS_NONE_HINT' | translate }}
                </p>
              </div>
            </div>

            <div class="v2-rpc-item" *ngIf="pcents > 0 || numSpinners >= 1">
              <div
                class="v2-ob-secondary-actions v2-open-binders-empty-rpc__secondary"
                role="region"
                aria-labelledby="v2-ob-secondary-heading-rpc"
              >
                <h2 class="v2-ob-eyebrow" id="v2-ob-secondary-heading-rpc">{{ 'OPEN_BINDERS_MORE_OPTIONS' | translate }}</h2>
                <app-btn
                  *ngIf="pcents > 0"
                  class="v2-rpc-action-btn"
                  [text]="'V2_OVERLAY_BUY_MORE' | translate"
                  icon="chevron-forward-outline"
                  [type]="operationInProgress ? 'disabled' : 'neutral'"
                  (clicked)="gotoGet()"
                ></app-btn>

                <app-btn
                  *ngIf="numSpinners >= 1"
                  class="v2-rpc-action-btn"
                  [text]="'OPEN_SPINNERS' | translate"
                  icon="chevron-forward-outline"
                  [type]="operationInProgress ? 'disabled' : 'neutral'"
                  (clicked)="gotoOpenSpinners()"
                ></app-btn>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  </ng-container>
</div>
